import { AfterContentInit, ContentChild, Directive, Self } from '@angular/core';
import { NgForOf } from '@angular/common';
import { FormControlName } from '@angular/forms';
import { I360FormControl } from 'app/utils/validator/form-control';

@Directive({
    selector: 'mat-select[formControlName]',
})
export class SelectFormControlNameDirective implements AfterContentInit {
    @ContentChild(NgForOf, {static: true}) ngForOf: NgForOf<any>;
    constructor(@Self() private formControlName: FormControlName) {}
    ngAfterContentInit() {
        const control = <I360FormControl<any>>this.formControlName.control;
        if (control.allowedValues) {
            this.ngForOf.ngForOf = control.allowedValues;
        }
    }
}
